import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import { FilterExpansionPanel, FilterExpansionPanelProps } from 'embeds/components';
import { map } from 'lodash';

import FilterByMe, { FilterByMeProps } from './FilterByMe';
import FilterChatActivityAssignees, { FilterChatActivityAssigneesProps } from './FilterChatActivityAssignees';
import FilterFacilities, { FilterFacilitiesProps } from './FilterFacilities';
import FilterGroups, { FilterGroupsProps } from './FilterGroups';

const components = {
  chatActivityAssignees: FilterChatActivityAssignees,
  facilities: FilterFacilities,
  groups: FilterGroups,
  me: FilterByMe,
};

const styles = ({
  palette: {
    common: { white },
  },
}: Theme) =>
  createStyles({
    root: {
      background: white,
      height: '100%',
      width: '100%',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    },
  });

export type FilterType = keyof typeof components;

export type FilterProps = Omit<FilterExpansionPanelProps, 'classes'> & {
  componentProps?: Omit<
    FilterChatActivityAssigneesProps | FilterFacilitiesProps | FilterGroupsProps | FilterByMeProps,
    'classes'
  >;
};

export interface FiltersProps extends WithStyles<typeof styles> {
  filters: Partial<Record<FilterType, FilterProps>>;
}

const Filters: React.FC<FiltersProps> = ({ classes, filters, ...rest }) => (
  <div className={classes.root} {...rest}>
    {map(filters, (filter, type) => {
      if (!filter) {
        return null;
      }
      const { componentProps, ...filterProps } = filter;
      const Component = components[type as FilterType];
      return (
        <FilterExpansionPanel key={type} {...filterProps}>
          <Component {...componentProps} />
        </FilterExpansionPanel>
      );
    })}
  </div>
);

export default withStyles(styles)(Filters);
